import { render, staticRenderFns } from "./QuestionMult2.vue?vue&type=template&id=31bd00f6&scoped=true&"
import script from "./QuestionMult2.vue?vue&type=script&lang=js&"
export * from "./QuestionMult2.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMult2.vue?vue&type=style&index=0&id=31bd00f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd00f6",
  null
  
)

export default component.exports